import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, API_ENDPOINTS } from '@core';
import {
  InteriorPaintRoomHeightsResponse,
  InteriorPaintRoomHeightsSaveRequest,
  InteriorPaintRoomHeightsSaveResponse,
  InteriorPaintDrawerResponse,
  InteriorPaintDrawerSaveRequest,
  InteriorPaintDrawerSaveResponse,
} from '@core/models/project.models';
import { ApiResponse } from '@core/models/api.models';

@Injectable()
export class InteriorPaintApiService {
  private readonly api = inject(ApiService);

  getPricingDrawer(projectId: number): Observable<ApiResponse<InteriorPaintDrawerResponse>> {
    return this.api.get<InteriorPaintDrawerResponse>(
      API_ENDPOINTS.project.pricingDrawerInteriorPaints(projectId),
    );
  }

  savePricingDrawer(
    projectId: number,
    payload: InteriorPaintDrawerSaveRequest,
  ): Observable<ApiResponse<InteriorPaintDrawerSaveResponse>> {
    return this.api.post<InteriorPaintDrawerSaveResponse>(
      API_ENDPOINTS.project.pricingDrawerInteriorPaints(projectId),
      payload,
    );
  }

  getRoomHeights(projectId: number): Observable<ApiResponse<InteriorPaintRoomHeightsResponse>> {
    return this.api.get<InteriorPaintRoomHeightsResponse>(API_ENDPOINTS.project.interiorPaintRoomHeights(projectId));
  }

  saveRoomHeights(
    projectId: number,
    payload: InteriorPaintRoomHeightsSaveRequest,
  ): Observable<ApiResponse<InteriorPaintRoomHeightsSaveResponse>> {
    return this.api.post<InteriorPaintRoomHeightsSaveResponse>(
      API_ENDPOINTS.project.interiorPaintRoomHeights(projectId),
      payload,
    );
  }
}
